import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface KeycloakTokenDTO {
  accessToken: string;
  refreshToken: string;
}

export class KeycloakToken {
  readonly isKeycloakTokenKeycloakToken: boolean = true;

  readonly accessToken: string;
  readonly refreshToken: string;


  constructor(
  accessToken: string, 
  refreshToken: string
  ) {
    KeycloakToken.validateAccessToken(accessToken);
    this.accessToken = accessToken;
    KeycloakToken.validateRefreshToken(refreshToken);
    this.refreshToken = refreshToken;
  }

  static fromDTO(dto: KeycloakTokenDTO): KeycloakToken {
    const accessToken = getString(dto, "accessToken", InvalidKeycloakTokenAccessTokenError);
    const refreshToken = getString(dto, "refreshToken", InvalidKeycloakTokenRefreshTokenError);
    return new KeycloakToken(
      accessToken,
      refreshToken
    );
  }

  toDTO(): KeycloakTokenDTO {
    const dto: KeycloakTokenDTO = {
        accessToken: this.accessToken,
        refreshToken: this.refreshToken
    };
    return dto;
  }
  private static validateAccessToken = (accessToken: string): void => {
    if(accessToken.trim().length === 0) {
      throw new InvalidKeycloakTokenAccessTokenNonEmptyError(
        `Attribute accessToken cannot be an empty string.`
      );
    }
  }
  private static validateRefreshToken = (refreshToken: string): void => {
    if(refreshToken.trim().length === 0) {
      throw new InvalidKeycloakTokenRefreshTokenNonEmptyError(
        `Attribute refreshToken cannot be an empty string.`
      );
    }
  }
  
}

KeycloakToken.prototype.toString = function toString(): string {
  return `KeycloakToken(accessToken='${this.accessToken}',refreshToken='${this.refreshToken}')`;
};

export class InvalidKeycloakTokenError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakTokenError";
  }
}
export class InvalidKeycloakTokenAccessTokenError extends InvalidKeycloakTokenError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakTokenAccessTokenError";
  }
}

export class InvalidKeycloakTokenAccessTokenNonEmptyError extends InvalidKeycloakTokenAccessTokenError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakTokenAccessTokenNonEmptyError";
  }
}

export class InvalidKeycloakTokenRefreshTokenError extends InvalidKeycloakTokenError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakTokenRefreshTokenError";
  }
}

export class InvalidKeycloakTokenRefreshTokenNonEmptyError extends InvalidKeycloakTokenRefreshTokenError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidKeycloakTokenRefreshTokenNonEmptyError";
  }
}
